import React, { useEffect, useContext } from 'react';
import { useParams, Outlet } from 'react-router-dom';
import { WidgetsContext, AppContext } from '../../GlobalContex';
import useNotifications from '../../hooks/useNotifications';
import Api from '../../../api/api';

export default function Widget() {
  const { activeWidget, widgets, setActiveWidget, setCtxWidget } = useContext(WidgetsContext);
  const { isEmbeded, setIsLoading } = useContext(AppContext);
  const { widgetId } = useParams();
  const notification = useNotifications();

  useEffect(() => {
    // try to find widget in WidgetsContext.widgets
    if (widgets.length) {
      const widget = widgets.find(widget => widget.id === Number(widgetId));
      if (widget) {
        isEmbeded() && setCtxWidget(widget);
        return setActiveWidget(widget);
      }
    }

    Api.loadWidget(widgetId)
      .then(widget => {
        isEmbeded() && setCtxWidget(widget);
        setActiveWidget(widget);
      })
      .catch(err => {
        console.log(err);
        notification.error(err.message);
        if (isEmbeded()) {
          //block user interface
          setIsLoading(true);
        }
      });
  }, [widgetId]);
  return activeWidget?.id ? <Outlet /> : <></>;
}
